import * as React from 'react';
import Button, { BUTTON_TYPES } from '@buyside/components/presentation/Button/button';

import { PreviousButtonProps } from '@interfaces/wizard/wizard';

const PreviousButton: React.FunctionComponent<PreviousButtonProps> = ({
  previous,
  previousText,
  ...props
}): React.ReactElement => (
  <Button
    type={BUTTON_TYPES.PRIMARY}
    text={previousText || 'Previous'}
    onClick={previous}
    {...props}
  />
);

export default PreviousButton;
